import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/fiar/FiAR_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/fiar/FiAR_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/fiar/FiAR_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/fiar/FiAR_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/fiar/FiAR_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/fiar/FiAR_Slider_6.jpg';

import Data_FiAR from './Data_FiAR';

function Work_FiAR() {
    return (
        <>
            <DetailedHeader
                heading="A New Standard for Fire Extinguisher Training"
                client="NORCAT"
                service="Augmented Reality"
                date="2020-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrls={[
                    'https://www.youtube.com/watch?v=aHqvqrLB4tY',
                    'https://www.youtube.com/watch?v=mmz5ZOw39MQ',
                ]}
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                  
                ]}
            />

            {Data_FiAR.content}
        </>
    );
}

export default Work_FiAR;
